import { FormLabel } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import customCheckboxRadioSwitch from 'assets/jss/material-dashboard-pro-react/customCheckboxRadioSwitch';
import Danger from 'components/Typography/Danger';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import CustomInput from 'components/CustomInput/CustomInput';
import InfoIconTooltip from 'components/InfoIconTooltip/InfoIconTooltip';

const useStyles = makeStyles({
  labelHorizontal: customCheckboxRadioSwitch.labelHorizontal,
});

const FormTextInput = ({
  label,
  classes: propClasses = {},
  success,
  error,
  helpText,
  handleChange,
  multiline,
  inputSize,
  rows,
  rowsMax,
  name,
  value,
  type,
  disabled,
  noMargin,
  noGrid,
  tooltip,
  maxLength,
  noAutoComplete,
  errors = {},
  ...props
}) => {
  const classes = useStyles();

  const errorMessage = errors[name] || false;

  return (
    <GridContainer alignItems="center">
      <GridItem xs={12} sm={inputSize}>
        <FormLabel
          className={propClasses?.labelHorizontal || classes.labelHorizontal}
        >
          {label} {tooltip && <InfoIconTooltip title={tooltip} />}
        </FormLabel>

        <CustomInput
          success={success}
          error={error}
          required={true}
          helpText={helpText}
          maxLength={maxLength}
          formControlProps={{
            fullWidth: true,
          }}
          name={name}
          inputProps={{
            'data-cy': `input_${name}`,
            max: 12,
            multiline,
            onChange: event => handleChange(event),
            value,
            type: type || 'text',
            rows,
            rowsMax,
            name,
            disabled: disabled || false,
            autoComplete: noAutoComplete ? 'new-password' : 'on',
            ...props,
          }}
        />
        {errorMessage && <Danger>{errorMessage}</Danger>}
      </GridItem>
    </GridContainer>
  );
};

export default FormTextInput;
